import { detect } from 'detect-browser';

const browser = detect();
export const isIOS = browser && browser.name === 'ios';
